import { render, staticRenderFns } from "./Listagem.vue?vue&type=template&id=5f0cb3fc&scoped=true&"
import script from "./Listagem.vue?vue&type=script&lang=js&"
export * from "./Listagem.vue?vue&type=script&lang=js&"
import style0 from "./Listagem.vue?vue&type=style&index=0&id=5f0cb3fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0cb3fc",
  null
  
)

export default component.exports